import { Injectable } from "@angular/core";
import { GraphicsRenderRuler } from "../digital-twin/graphics/graphics-render-ruler";

@Injectable({ providedIn: 'root' })
export class RulerInsertion {
    constructor(
        private graphicsRenderRuler: GraphicsRenderRuler,
    ) { }

    public insertRuler(ev) {
        this.graphicsRenderRuler.flagToStartDrawing();
    }
}
